module.exports = __webpack_public_path__ + "img/chapter__10_image_3.de3110a4.png";